import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { MyDatePicker } from "mydatepicker";
import { IMyDpOptions } from "mydatepicker";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
const days = [
  { id: 1, name: "monDay", value: "Monday" },
  { id: 1, name: "tueDay", value: "Tuesday" },
  { id: 1, name: "wedDay", value: "Wednesday" },
  { id: 1, name: "thuDay", value: "Thursday" },
  { id: 1, name: "friDay", value: "Friday" },
  { id: 1, name: "satDay", value: "Saturday" },
  { id: 1, name: "sunDay", value: "Sunday" },
];

@Component({
  selector: "app-waiting-list",
  templateUrl: "./waiting-list.component.html",
  styleUrls: ["./waiting-list.component.scss"],
  providers: [DatePipe],
})
export class WaitingListComponent implements OnInit {
  scheduleID = "";
  scheduleDetails: any = {};
  scheduleDetail: any = {};
  selectProcedureList: any = [];
  patientList: any = [];
  selectedName = "";
  confirmForm: FormGroup;
  countryList: any = [];
  phonemask = "00000-00000";
  isSubmit = false;
  submitted = false;
  fromTimeArray = environment.initialTime;
  patientID = "";
  testCountryCode = "";

  workFromTimeArray = environment.initialTimeNewObject;
  workToTimeArray = environment.initialTimeNew;
  fromHourslowValue = 0;
  today: any = new Date();
  workingHours: any = [];
  toHoursHighValue = 0;
  selectedTime1Object: any;
  selectedTime2Object: any;
  selectedTime3Object: any;
  selectedTime4Object: any;
  toWorkHoursArray1 = [];
  toWorkHoursArray2 = [];
  firstDate = false;
  secondDate = false;
  @ViewChild("mydp") mydp: MyDatePicker;
  public myDatePickerOptions: IMyDpOptions = {};
  constructor(
    private appservice: AppService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router
  ) {
    const date = new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: "mmm d, yyyy",
      editableDateField: false,
      disableUntil: { year: year, month: month, day: date.getDate() },
    };
  }

  insuranceList = [];
  formatter: any;

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    if (routeParams.patientID) {
      this.scheduleID = routeParams.patientID;
      if (this.scheduleID) {
        this.getScheduledetails();
      }
    }

    this.getPatientList();

    this.loadForm();

    this.getcountry();
    this.viewTestCenter();
    this.formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
    const scheduleData = sessionStorage.getItem("scheduleData")
      ? JSON.parse(sessionStorage.getItem("scheduleData"))
      : "";
    if (scheduleData) {
      this.scheduleDetail = scheduleData;

      this.insuranceList = [];
      if (
        this.scheduleDetail.payMode === "insurance" &&
        this.scheduleDetail.insuranceList.length > 0
      ) {
        for (
          let index = 0;
          index < this.scheduleDetail.insuranceList.length;
          index++
        ) {
          const data = {
            insurance: this.scheduleDetail.insuranceList[index].insName,
            insuranceId: this.scheduleDetail.insuranceList[index].insId,
            insuranceType: this.scheduleDetail.insuranceList[index].insType,
            insuranceIdNumber: "",
            insuranceGroupNumber: "",
            insuranceCustomerService: "",
            insuranceCustomerServiceMask: "",
            insuranceCustomerCode: "",
          };
          this.insuranceList.push(data);
        }
      }

      if (
        scheduleData.selectProcedureList &&
        scheduleData.selectProcedureList.length > 0
      ) {
        this.selectProcedureList = scheduleData.selectProcedureList;
        scheduleData.procedureInputs = [];
        scheduleData.selectProcedureList.forEach((procedure) => {
          const detail: any = {};
          detail.disabled = false;
          detail.cptCode = procedure.cptCode;
          detail.examId = procedure.examId;
          detail.procedureName = procedure.procedureName;
          detail.procedureId = procedure.procedureID;
          detail.duration = procedure.duration;
          scheduleData.procedureInputs.push(detail);
        });
      }
    }
  }

  firstDateCheck(event, index) {
    this.confirmForm.controls["firstitems"]["controls"][index]["controls"][
      "scheduledOnStr"
    ].setValue(this.datepipe.transform(event.jsdate, "yyyy-MM-dd"));
    this.appservice
      .checkGivenDateIsHolidayOrNot(
        this.confirmForm.controls["firstitems"]["controls"][index]["controls"][
          "scheduledOnStr"
        ].value
      )
      .subscribe((res) => {
        if (res["status"]["status"] === 200) {
          this.firstDate = false;
        } else {
          this.firstDate = true;
        }
      });
  }

  secondDateCheck(event, index) {
    this.confirmForm.controls["Nesteditems"]["controls"][index]["controls"][
      "scheduledOnStr"
    ].setValue(this.datepipe.transform(event.jsdate, "yyyy-MM-dd"));
    this.appservice
      .checkGivenDateIsHolidayOrNot(
        this.confirmForm.controls["Nesteditems"]["controls"][index]["controls"][
          "scheduledOnStr"
        ].value
      )
      .subscribe((res) => {
        if (res["status"]["status"] === 200) {
          this.secondDate = false;
        } else {
          this.secondDate = true;
        }
      });
  }

  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            if (this.testCountryCode === "US") {
              this.confirmForm.controls["countrydialcode"].setValue("+1");
              this.phonemask = "(000) 000-0000";
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
              });
            } else {
              this.confirmForm.controls["countrydialcode"].setValue("+91");
              this.phonemask = "00000-00000";
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              });
            }

            this.workingHours = res["entity"]["workingHours"];
            this.setCalendarTime();
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  cancelWaitingList() {
    this.router.navigate([
      `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
    ]);
  }

  loadForm() {
    this.confirmForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      countrydialcode: ["+91"],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      mobileExtn: [""],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$/),
        ],
      ],
      gender: ["", Validators.required],
      preAutherize: ["false"],
      preNeed: [""],
      preReminder: [""],
      alternativeMobile: [""],
      alternativeCode: ["+91"],
      alternativeExtn: [""],
      hearAbout: [""],
      hearOthers: [""],
      // PHYSICIAN DETAILS
      physicianFirstName: [""],
      physicianLastName: [""],
      doctorFirstName: [""],
      doctorLastName: [""],
      physicianMobile: [""],
      physicianMobileCode: ["+91"],
      physicianExtn: [""],
      physicianFax: [""],
      faxCode: ["+91"],
      faxExtn: [""],
      hmoFirstName: [""],
      hmoLastName: [""],
      hmoMobile: [""],
      hmoMobileCode: ["+91"],
      hmoExtn: [""],
      firstitems: this.formBuilder.array([this.createItem()]),
      Nesteditems: this.formBuilder.array([this.createItem()]),
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      scheduledOnStr: ["", Validators.required],
      startTime: ["", Validators.required],
      endTime: [""],
    });
  }

  addItem(): void {
    const items = this.confirmForm.get("Nesteditems") as FormArray;
    items.push(this.createItem());
  }

  removeList(index: number) {
    const add = this.confirmForm.get("Nesteditems") as FormArray;
    add.removeAt(index);
  }

  getcountry() {
    this.appservice.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.countryList = res["entity"];
        } else {
          this.countryList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      this.phonemask = this.appservice.checkDialCode(value);
    }
  }

  getPatientList() {
    this.appservice.getAllPatient().subscribe((patient: any) => {
      if (patient.status.status === 200) {
        this.patientList = patient.entity;
        if (this.patientList.length > 0) {
          this.patientList.forEach((patientData) => {
            patientData.username =
              patientData.firstName + " " + patientData.lastName;
          });
        }
      }
    });
  }

  onSelect(event: TypeaheadMatch): void {
    this.confirmForm.controls["firstName"].setValue(event.item.firstName);
    this.confirmForm.controls["lastName"].setValue(event.item.lastName);
    this.confirmForm.controls["mobile"].setValue(event.item.patientPhone);
    this.confirmForm.controls["mobileExtn"].setValue(
      event.item.patientPhoneExtn
    );
    this.confirmForm.controls["countrydialcode"].setValue(
      event.item.patientPhoneCode
    );
    this.confirmForm.controls["email"].setValue(event.item.patientEmail);
    this.confirmForm.controls["gender"].setValue(event.item.gender);
    this.confirmForm.controls["gender"].setValue(event.item.gender);
    this.patientID = event.item.id;
  }

  getScheduledetails() {
    this.appservice
      .viewscheduleappointmentpro(this.scheduleID)
      .subscribe((scheduleDetail: any) => {
        if (scheduleDetail.status.status === 200) {
          this.scheduleDetails = scheduleDetail.entity;
          this.scheduleDetail = this.scheduleDetails.schedule;
          if (this.scheduleDetails.procedures.length > 0) {
            this.selectProcedureList = this.scheduleDetails.procedures;
          }
        }
      });
  }

  onToggleCalendar(event: any): void {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }

  get f() {
    return this.confirmForm.controls;
  }

  onSubmit() {
    document.getElementById("formButton").click();
  }

  onSubmit1() {
    this.submitted = true;
    if (!sessionStorage.getItem("scheduleData")) {
      this.toastr.error("First Fill Schedule Appointment");
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
      ]);
    } else {
      // stop here if form is invalid
      if (this.confirmForm.invalid || this.firstDate || this.secondDate) {
        return;
      }
      if (this.scheduleDetail.procedureInputs) {
        this.isSubmit = true;
        const params: any = {};
        params.patientFirstName = this.confirmForm.controls["firstName"].value;
        params.patientLastName = this.confirmForm.controls["lastName"].value;
        params.patientEmail = this.confirmForm.controls["email"].value;
        params.patientPhoneCode = this.confirmForm.controls[
          "countrydialcode"
        ].value;
        params.patientPhone = this.confirmForm.controls["mobile"].value;
        params.patientId = "";
        params.gender = this.confirmForm.controls["gender"].value;
        if (params.patientId) {
          this.addWaiting(params);
        } else {
          this.addPatient(params);
        }
      } else {
        this.toastr.error("First Fill Schedule Appointment");
        this.router.navigate([
          `/${localStorage
            .getItem("testCode")
            .toString()}/schedule-appointment`,
        ]);
      }
    }
  }

  addPatient(params) {
    this.appservice.addorupdatepatient(params).subscribe(
      (patientDetail: any) => {
        if (patientDetail.status.status === 200) {
          delete params.patientId;
          params.id = patientDetail.entity.id;
          this.addWaiting(params);
        }
      },
      (err) => {
        this.isSubmit = false;
      }
    );
  }

  addWaiting(params) {
    if (
      this.scheduleDetail.payMode === "insurance" &&
      this.insuranceList &&
      this.insuranceList.length > 0
    ) {
      var schedInsuranceInput = [];
      for (let index = 0; index < this.insuranceList.length; index++) {
        schedInsuranceInput.push({
          insuranceGroupNumber: this.insuranceList[index].insuranceGroupNumber,
          insuranceIdNumber: this.insuranceList[index].insuranceIdNumber,
          insuranceCustomerCode: this.insuranceList[index]
            .insuranceCustomerCode,
          insuranceCustomerService: this.insuranceList[index]
            .insuranceCustomerService,
          insurance: { id: this.insuranceList[index].insuranceId },
          insuranceType: { id: this.insuranceList[index].insuranceType },
        });
      }
    }
    const params1: any = {
      scheduleId: this.scheduleDetail.scheduleId,
      scheduledOn: this.scheduleDetail.scheduleOn,
      scheduledOnStr: this.scheduleDetail.scheduleOn,
      choosenLocation: this.scheduleDetail.location,
      latitude: this.scheduleDetail.latitude,
      longitude: this.scheduleDetail.longitude,
      payMode: this.scheduleDetail.payMode,
      schedInsuranceInput:
        schedInsuranceInput && schedInsuranceInput.length > 0
          ? schedInsuranceInput
          : null,
      procedureInputs: this.scheduleDetail.procedureInputs,
      preAuthorized: true,
      timeZone: this.scheduleDetail.timeZone,
      totalAmount: 0,
      schedMed: true,
      schedStatusId: 1,
      testCenterId: localStorage.getItem("testCenterId").toString(),
    };
    params1.waitingInputs = [];
    let nestedParams: any = [];
    nestedParams = this.confirmForm.controls["Nesteditems"]["value"];

    if (nestedParams.length > 0) {
      nestedParams.forEach((waiting) => {
        if (waiting.scheduledOnStr) {
          if (waiting.scheduledOnStr.formatted) {
            waiting.scheduledOnStr = this.datepipe.transform(
              waiting.scheduledOnStr.jsdate,
              "yyyy-MM-dd"
            );
          }
        }
      });
      params1.waitingInputs = nestedParams;
    }
    params1.waitingInputs.push({
      scheduledOnStr: this.confirmForm.controls["firstitems"]["controls"][0][
        "controls"
      ]["scheduledOnStr"].value,
      startTime: this.confirmForm.controls["firstitems"]["value"][0].startTime,
      endTime: this.confirmForm.controls["firstitems"]["value"][0].endTime,
    });

    if (
      params1.waitingInputs[0].scheduledOnStr ===
      params1.waitingInputs[1].scheduledOnStr
    ) {
      this.toastr.error("Both are same date, Please change another day");
      this.isSubmit = false;
      return;
    }

    params1.patient = {};
    params1.patient.id = this.patientID ? this.patientID : params.id;
    params1.patient.firstName = params.patientFirstName;
    params1.patient.lastName = params.patientLastName;
    params1.patient.patientEmail = params.patientEmail;
    params1.patient.patientPhone = params.patientPhone;
    params1.patient.patientPhoneCode = params.patientPhoneCode;
    params1.patient.gender = params.gender;

    delete params1.procedureInputs;
    params1.cptCodes = this.scheduleDetail.cptCodeList;
    params1.scheduleFromTime = this.confirmForm.controls["firstitems"][
      "value"
    ][0].startTime;
    params1.scheduleToTime = this.confirmForm.controls["firstitems"][
      "value"
    ][0].endTime;
    this.appservice.scheduleWaitingList(params1).subscribe(
      (schedule: any) => {
        if (schedule.status.status === 200) {
          this.firstDate = false;
          this.secondDate = false;
          if (schedule.entity) {
            const updateSchedule: any = {};
            this.isSubmit = false;
            sessionStorage.removeItem("scheduleData");
            this.toastr.success("Appointments Waiting list Added Successfully");
            this.router.navigate([
              `/${localStorage
                .getItem("testCode")
                .toString()}/waiting-list-history`,
            ]);
          }
        } else if (schedule.status.status === 205) {
          this.firstDate = true;
          this.secondDate = false;
          this.isSubmit = false;
        } else if (schedule.status.status === 206) {
          this.firstDate = false;
          this.secondDate = true;
          this.isSubmit = false;
        }
      },
      (err) => {
        this.isSubmit = false;
      }
    );
  }

  setCalendarTime() {
    const getDate = moment(this.today).format("dddd");
    if (this.workingHours.length > 0) {
      days.forEach((day) => {
        if (day.value === getDate) {
          this.workingHours.forEach((work) => {
            if (work.workHourType === "work") {
              this.convertFromTimeformat(work.fromHour);
              this.convertToTimeformat(work.toHour);
            }
          });
        }
      });
    }
  }

  private parseTimeToFloat(str) {
    const time = str;
    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s(AM|PM)$/i)[1];
    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return parseFloat(sHours + "." + sMinutes);
  }

  convertFromTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.fromHourslowValue === 0) {
      this.fromHourslowValue = result;
    }
    if (result <= this.fromHourslowValue) {
      this.fromHourslowValue = result;
    }
  }

  convertToTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.toHoursHighValue === 0) {
      this.toHoursHighValue = result;
    }
    if (result >= this.toHoursHighValue) {
      this.toHoursHighValue = result;
    }
  }

  getFromWorkHoursIndex1(value, index) {
    environment.initialTimeNewObject.forEach((obj) => {
      if (obj.value === value) {
        this.selectedTime1Object = obj;
      }
    });
    const keyNew = this.selectedTime1Object;
    const floatKey = parseFloat(keyNew.key);
    environment.initialTimeNewObject.forEach((obj) => {
      const keysFLoat = parseFloat(obj.key);
      if (floatKey < keysFLoat && this.toHoursHighValue > keysFLoat) {
        this.toWorkHoursArray1.push(obj);
      }
    });
  }

  getFromWorkHoursIndex2(value, index) {
    environment.initialTimeNewObject.forEach((obj1) => {
      if (obj1.value === value) {
        this.selectedTime1Object = obj1;
      }
    });
    const keyNew = this.selectedTime1Object;
    const floatKey = parseFloat(keyNew.key);
    environment.initialTimeNewObject.forEach((obj) => {
      const keysFLoat = parseFloat(obj.key);
      if (floatKey < keysFLoat && this.toHoursHighValue > keysFLoat) {
        this.toWorkHoursArray2.push(obj);
      }
    });
  }
}
